import { render, staticRenderFns } from "./ProposalOfficeInsurance.vue?vue&type=template&id=1beb0df0"
import script from "./ProposalOfficeInsurance.vue?vue&type=script&lang=js"
export * from "./ProposalOfficeInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports